import React from 'react';
import styled from 'styled-components';

import Section from './global/section';
import ButtonA from './global/button-a';

const StyledEducation = styled.div`
	.box {
		display: flex;
		margin: 2rem 3rem;
		padding: 2rem;
		border-radius: 20px;
		background-color: ${(p) => p.theme.color.purple};
		background-image: url(/img/Purple_Blob.svg);
		background-position: 110% 100%;
		background-size: 400px;
		background-repeat: no-repeat;

		.red {
			color: ${(p) => p.theme.color.red};
		}
		.teal {
			color: ${(p) => p.theme.color.teal};
		}
		.green {
			color: ${(p) => p.theme.color.green};
		}
		.yellow {
			color: ${(p) => p.theme.color.yellow};
		}
		.img-col {
			width: 30%;
			position: relative;
			.img-wrap {
				position: relative;
			}
			.photo {
				border: 4px solid #fff;
				position: relative;
				z-index: 2;
			}
			.circle {
				position: absolute;
				z-index: 1;
				right: 5rem;
				top: 50%;
				transform: translateY(-50%);
				width: calc(100% + 7rem);
				max-width: none;
			}
			p {
				position: absolute;
				z-index: 3;
				bottom: 1rem;
				left: 1rem;
				font-weight: 700;
				font-size: 1.5rem;

				text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);

				span {
					position: relative;
					font-family: ${(p) => p.theme.fonts.heading};
					left: 0;
					transition: 0.3s left;
				}
			}

			a:hover p span {
				left: 0.7rem;
			}
		}
		.text-col {
			width: 70%;
			color: #fff;
			padding-left: 4rem;
			display: flex;
			flex-direction: column;

			h2 {
				font-size: 2rem;
				margin-bottom: 1rem;
			}
			.text-inner {
				flex-grow: 2;
				flex-shrink: 2;
				display: flex;
				flex-direction: column;
				justify-content: center;

				.story {
					margin-bottom: 1.5rem;
				}

				.cta {
					.phone {
						display: block;
						margin-bottom: 0.5em;

						&:last-of-type {
							margin-bottom: 2rem;
						}

						p {
							display: inline-block;
							font-weight: 700;
							margin-right: 0.5em;
							line-height: 1.2;
						}
						a {
							position: relative;
							&::after {
								content: '';
								background-color: #fff;
								transition: 0.3s opacity;
								width: 100%;
								height: 1px;
								position: absolute;
								bottom: 0;
								right: 0;
								opacity: 0;
							}
							&:hover::after {
								opacity: 1;
							}
						}
					}
				}
			}
		}
	}
	@media all and (max-width: 1000px) {
		section {
			padding: 3rem 0;
		}
		.box {
			margin: 2rem 1rem;
			background-position: 110% -4rem;
			background-size: 300px;
			.img-col {
				width: 25%;
				.circle {
					display: none;
				}
				p {
					bottom: 0.25rem;
				}
			}
			.text-col {
				width: 75%;
				padding-left: 3rem;
			}
		}
	}
	@media all and (max-width: 1000px) and (min-width: 879px) {
		.box .img-col p {
			left: 0.5rem;
			span {
				display: none;
			}
		}
	}
	@media all and (max-width: 878px) {
		.box {
			flex-direction: column;
			background-position: 150% 80%;
			background-size: 80% auto;
			.img-col {
				width: 100%;
				.photo {
					max-width: 450px;
					width: 100%;
				}
			}
			.text-col {
				width: 100%;
				padding-left: 0;
				margin-top: 2rem;
			}
		}
	}
	@media all and (max-width: 350px) {
		.box .img-col p {
			font-size: 1.3rem;
		}
	}
`;

export default () => {
	return (
		<StyledEducation>
			<Section bg="dark">
				{education.map((item, index) => (
					<div className="box" key={index} id={item.id}>
						<div className="img-col">
							<a href={item.caption.href}>
								<div className="img-wrap">
									<p href={item.caption.href}>
										{item.caption.text} <span className={item.color}>></span>
									</p>
									<img
										className="photo"
										src={item.photo}
										alt="person headshot"
									/>
								</div>
							</a>
							<img
								className="circle"
								src={`/img/${item.color}.svg`}
								alt="colored circle"
							/>
						</div>
						<div className="text-col">
							<h2>
								<span className={item.color}>></span> {item.title}
							</h2>
							<div className="text-inner">
								<p className="story">{item.content}</p>
								<div className="cta">
									{item.phone.map((contact, i) => (
										<div className="phone" key={`${contact.link}-${i}`}>
											<p>{contact.top}</p>
											<a href={contact.link}>{contact.text}</a>
										</div>
									))}
									<ButtonA
										target="_blank"
										rel="noopener noreferrer"
										href={item.cta}
										bg="teal"
									>
										MORE INFO
									</ButtonA>
								</div>
							</div>
						</div>
					</div>
				))}
			</Section>
		</StyledEducation>
	);
};

const education = [
	{
		id: 'mental-health',
		title: 'Mental Health Awareness',
		caption: {
			href: '/stories/#alex',
			text: "Alex's Story",
		},
		color: 'green',
		content:
			'Your personal mental health balance will be unique, and your challenge will be to stay mentally healthy by keeping your balance. Just as physical fitness helps our bodies to stay strong, mental fitness helps us to achieve and sustain a state of good mental health. When we are mentally healthy, we enjoy our life and environment, and the people in it. Click the link below to find out more.',
		photo: '/img/Alex.jpg',
		cta: 'https://ontario.cmha.ca/mental-health/',
		phone: [
			{
				text: '1-888-893-8333',
				link: 'tel:+18888938333',
				top: 'Mental Health Crisis Line',
			},
		],
	},
	{
		id: 'suicide',
		title: 'Suicide Awareness',
		caption: {
			href: '/stories/#maria',
			text: "Maria's Story",
		},
		color: 'teal',
		content:
			'It is difficult to determine who is, or who might become suicidal. Suicide may be prevented if we know the signs and symptoms, risk factors, and where to go for help. Persons at risk for suicide usually show one or more warning signs. However, it may be possible that there will be no warning signs at all. Check the link below for more info, including the common warning signs to look for.',
		photo: '/img/Kayley.jpg',
		cta:
			'https://ontario.cmha.ca/wp-content/uploads/2016/04/Preventing-Suicide-NTNL-brochure-2014-web.pdf',
		phone: [
			{
				text: '1-888-893-8333',
				link: 'tel:+18888938333',
				top: 'Mental Health Crisis Line',
			},
			{
				text: '1-705-326-9941',
				link: 'tel:+7053269941',
				top: 'Simcoe County Suicide Awareness Council',
			},
		],
	},
	{
		id: 'addictions',
		title: 'Addiction Awareness',
		caption: {
			href: '/stories/#john',
			text: "John's Story",
		},
		color: 'red',
		content:
			'Another word for addiction is “dependence.” There are two kinds of substance dependence: Psychological dependence occurs when a person feels he or she needs the drug to function or feel comfortable (e.g., needing to drink alcohol to feel relaxed in social situations, or needing to be high to enjoy sex). Some people come to feel they need a substance just to be able to cope with daily life.',
		photo: '/img/John.jpg',
		cta: 'https://ontario.cmha.ca/addictions/',
		phone: [
			{
				text: '1-888-565-8603',
				link: 'tel:+18885658603',
				top: 'Drug & Alcohol Helpline',
			},
		],
	},
	{
		id: 'youth-support',
		title: 'Youth Services & Support',
		caption: {
			href: '/stories/#emily',
			text: "Emily's Story",
		},
		color: 'yellow',
		content:
			'Prevention, early identification and early intervention are the foundation of an effective response and improved outcomes for emerging mental health and substance misuse concerns in youth. Like any health issue we are better equipped to assist or respond if we are able to recognize the signs and symptoms. Then we can seek assistance, just like we would a physical health issue.',
		photo: '/img/Emily.jpg',
		cta: 'https://ontario.cmha.ca/mental-health/child-and-youth-mental-health/',
		phone: [
			{
				text: '1-705-726-5033',
				link: 'tel:+17057265033',
				top: 'Early Psychosis Intervention',
			},
		],
	},
];
